import React, { Component, Fragment } from "react";

import * as actionCreaters from "../../Store/actions/index";
import { connect } from "react-redux";
import { auth } from "../../Firebase/firebase";
import ProfilePage from "../../Component/ProfilePage/Profile";
import MainToolBar from "../../Component/Navigation/MainToolBar/MainToolBar";
import Authentication from "../Authentication/Authentication";
import EditUserForm from "./EditUserForm";

class Profile extends Component {
    state = {
        showEditeUserForm: false,
        //Search state:
        searchInput: '',
        //Auth state :
        showAuth: false,
        authMode: 'signIn'
    }

    componentDidMount() {
        let token = localStorage.getItem('idToken')
        if (!token) {
            const fireUser = auth.currentUser
            if (fireUser) {
                fireUser.getIdToken(true)
                    .then(responseToken => {
                        token = responseToken
                    })
                    .catch(error => console.log(error))
            }
            else {
                console.log(fireUser)
            }
        }
        this.props.onGetUserProfile(token)
    }

    showEditeUserFormHandler = () => {
        this.setState((prevState) => { return { showEditeUserForm: !prevState.showEditeUserForm } })
    }

    searchInputHandler = (value) => {
        this.setState({
            searchInput: value
        })
    }

    reLoadSearchPageHandler = () => {
        //  console.log('tes')
    }

    showAuthHandler = (mode, kepShowing) => {
        if (kepShowing) {
            this.setState({ showAuth: true })
        } else {
            this.setState((prevState) => {
                return { showAuth: !prevState.showAuth }
            })
        }
        if (mode === 'signUp') {
            this.setState({
                authMode: 'signUp'
            })
        }
        else if (mode === 'signIn') {
            this.setState({
                authMode: 'signIn'
            })
        }
        else if (mode === 'passwordReset') {
            this.setState({
                authMode: 'passwordReset'
            })
        }
        else if (mode === 'verifyEmail') {
            this.setState({
                authMode: 'verifyEmail'
            })
        }
    }

    render() {
        let ProfileComponent = (
            <ProfilePage
                userProfile={this.props.userProfile}
                showEditeUserFormHandler={this.showEditeUserFormHandler} />);

        if (this.state.showEditeUserForm) {
            ProfileComponent = <EditUserForm  userProfile={this.props.userProfile} showEditeUserFormHandler={this.showEditeUserFormHandler}/>
        }

        return (
            <Fragment>
                {this.state.showAuth ?
                    <Authentication
                        showAuth={this.state.showAuth}
                        showAuthHandler={this.showAuthHandler}
                        authMode={this.state.authMode} />
                    :
                    null}
                <MainToolBar
                    searchInput={(value) => { this.searchInputHandler(value) }}
                    searchInputValue={this.state.searchInput}
                    props={{ ...this.props }}
                    reLoadSearchPage={this.reLoadSearchPageHandler}
                    showAuthHandler={this.showAuthHandler}
                    user={this.props.user} />
                {ProfileComponent}
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        // Auth related : 
        user: state.Auth.user,
        // User Profile :
        userProfile: state.Profile.userProfile
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onGetUserProfile: (token) => { dispatch(actionCreaters.getUserProfile(token)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);